import "./index.css"
import "./mobile.css"
import SectionBlock from "../cv-section-block/index.js";
import React, { useState, useEffect } from 'react';
import ChatBox from "../chatbox/index.js";

function SectionHolder(props) {
  useEffect(() => {
    animateBlocks()
    ; // Call the animation function when the component mounts
  }, []);
  

  const animateBlocks = () => {
    const sectionBlocks = document.querySelectorAll('.section-block');
    sectionBlocks.forEach((block, index) => {
      setTimeout(() => {
        block.setAttribute("class","section-block fadeup");
      }, 700 * index);
    });
  };

  const [divPositioning, setdivPositioning] = useState("0");
  const [sectionProperties,setSectionProperties] = useState({color:"#A367FD"});

const toggleDisplay = (sectionColor,sectionOpener,sectionTopic) => {
  setdivPositioning(prevDisplay => prevDisplay === "0" ? "-100vw" : "0");
  setSectionProperties({color:sectionColor,opener:sectionOpener,topic:sectionTopic});
};

  return <div className="action-holder" style={{marginLeft:divPositioning}}>
  <div className="wrapper">
  <div className="section-holder">
   <SectionBlock addFunction={() => toggleDisplay("#A367FD","Let's chat about coding!","coding")} imageSource="./icons/coding.png" title="Coding" description="Explore my love of coding and web development." />
   <SectionBlock addFunction={() => toggleDisplay("#FFA25F","Let's chat about my skills!","skills")} imageSource="./icons/skills.png" title="Skills" description="Check out my coding and marketing skillset." />
   <SectionBlock addFunction={() => toggleDisplay("#6AD2FF","Let's chat about my experience!","experience")} imageSource="./icons/experience.png" title="Experience" description="Find out more about my previous job roles." />
   <SectionBlock addFunction={() => toggleDisplay("#74F6A8","Let's chat about my education!","education")} imageSource="./icons/education.png" title="Education" description="Discover my educational qualifications." />
   <SectionBlock addFunction={() => toggleDisplay("#EE61F1","Let's chat about my career highlights!","highlights")} imageSource="./icons/highlights.png" title="Highlights" description="Uncover the data behind my career highlights." />
   <SectionBlock addFunction={() => toggleDisplay("#FF6060","Let's chat about my achievements!","achievements")} imageSource="./icons/achievements.png" title="Achievements" description="See my list of personal and professional achievements." />
  </div>
  </div>
  <div className="wrapper">
  <ChatBox addFunction={toggleDisplay} colorOfSection={sectionProperties.color} initialMessage={sectionProperties.opener} topic={sectionProperties.topic}>
  </ChatBox>
  </div>
  </div>
  }

export default SectionHolder;
